export default import.meta.ROLLUP_FILE_URL_07gvO1IvTzTCTyYqp_a5mw;